export default __webpack_public_path__ + "static/media/long_term.cd924216.svg";